<script setup lang="ts">
import BaseButton from '@/components/base/BaseButton.vue'
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import { useMultiplayerMine } from '@/composables/game/multiplayer-mine'
import mineTutorialBg from '@/assets/images/multiplayer/mine-tutorial-bg.png'
import mineIcon from '@/assets/images/multiplayer/mine-icon.png'
import mineMagnetIcon from '@/assets/images/multiplayer/mine-magnet-icon.webp'
import mineAntimineIcon from '@/assets/images/multiplayer/mine-antimine-icon.png'

defineProps<{
  show: boolean
}>()

const emit = defineEmits<{
  hide: []
}>()

const { hasSeenMineTutorial, openPlantMineModal } = useMultiplayerMine()

function onGotIt() {
  hasSeenMineTutorial.value = true
  openPlantMineModal()
  emit('hide')
}
</script>

<template>
  <TheBottomSheet
    :show="show"
    centered
    @hide="emit('hide')"
  >
    <div class="flex flex-col">
      <!-- Header with background image -->
      <div class="relative mb-6 flex justify-center overflow-hidden rounded-[13px] min-h-[71px] py-2 px-6">
        <img
          :src="mineTutorialBg"
          class="absolute inset-0 w-full h-full object-cover object-center"
          alt=""
        >
        <h2 class="relative z-10 font-pilat font-bold text-[32px] leading-[24px] text-white uppercase text-center">
          MINES
        </h2>
      </div>

      <!-- Pink subtitle -->
      <p class="font-semibold text-center text-base text-pink-primary mb-2" style="color: #F181F1;">
        Attack, defend, and steal coins!
      </p>

      <!-- Bullet rows -->
      <div class="flex flex-col gap-3 mb-2">
        <div class="flex items-center gap-3">
          <img
            :src="mineIcon"
            class="w-6 h-6 flex-shrink-0 object-contain"
            alt="Mine"
          >
          <p class="text-base font-semibold text-white/60">
            Place <span class="text-white/[.87]">mines</span> on a random player's card. If they upgrade that card, you steal their coins.
          </p>
        </div>
        <div class="flex items-center gap-3">
          <img
            :src="mineMagnetIcon"
            class="w-6 h-6 flex-shrink-0 object-contain"
            alt="Scanner"
          >
          <p class="text-base font-semibold text-white/60">
            <span class="text-white/[.87]">Use magnets</span> to collect all mines from your cards. They become yours to place!
          </p>
        </div>
        <div class="flex items-center gap-3">
          <img
            :src="mineAntimineIcon"
            class="w-6 h-6 flex-shrink-0 object-contain"
            alt="Anti-mine"
          >
          <p class="text-base font-semibold text-white/60">
            <span class="text-white/[.87]">Anti-mines</span> block attacks when you upgrade. You get coins as a reward.
          </p>
        </div>
      </div>

      <!-- Pink footnote -->
      <p class="text-base font-semibold text-center mb-6 text-pink-primary">
        You need to be level 5 to use mines.
      </p>

      <!-- GOT IT button -->
      <BaseButton
        class="w-full"
        @click="onGotIt"
      >
        GOT IT!
      </BaseButton>
    </div>
  </TheBottomSheet>
</template>
